export const oldReportTypes = ["RP", "RW", "WA"];
export const newReportTypes = ["IA", "AC", "IV", "BA", "UV", "IG", "UB", "PN", "NR", "IB", "II", "IC", "MB", "HW", "TT", "SK"];
/**
 * old and new report types (old ones will not be removed, but new ones are added)
 */
export const reportTypes = [...oldReportTypes, ...newReportTypes];
//# sourceMappingURL=reportTypes.js.map
